<template>
  <div class="pc-footer">
    <div class="pc-footer-content">
      <div class="top-wrap">
        <div class="company-information">
          <div class="title">公司資訊</div>
          <ul>
            <li
              v-for="(item, index) in companyInformation"
              :key="index"
              @click="toPage(item.url)"
            >
              {{ item.text }}
            </li>
          </ul>
        </div>
        <div class="helps">
          <div class="title">幫助</div>
          <ul>
            <li
              v-for="(item, index) in helps"
              :key="index"
              @click="goLink(item.url)"
            >
              {{ item.text }}
            </li>
          </ul>
        </div>
        <div class="info">
          <img
            class="logo"
            :src="logoFooter"
            alt="logo"
          />
          <div class="info-item">
            <div class="label">服務時間：</div>
            <div class="value">週一至週五 09:00 - 18:00</div>
          </div>
          <div class="info-item">
            <div class="label">公司名稱：</div>
            <div class="value">FAITH ONNET LIMITED</div>
          </div>
          <div class="info-item">
            <div class="label">聯絡地址：</div>
            <div class="value">
              Room 2003, 20th Floor, COFCO TOWER, No.262 Gloucester Road, Causeway Bay, Hong Kong
            </div>
          </div>
          <div class="info-item">
            <div class="label">聯絡郵箱：</div>
            <div class="value">service@seeronnet.com</div>
          </div>
          <div class="info-item">
            <div class="label">商務合作郵箱：</div>
            <div class="value">tarry@seerq.io</div>
          </div>
        </div>
      </div>

      <div class="center-wrap">
        <div class="we-accept">
          <div class="title">我們接受</div>
          <ul class="pay-list">
            <li
              v-for="(v, i) in payIconList"
              :key="i"
            >
              <img
                class="pay-icon"
                :src="v"
                alt=""
              />
            </li>
          </ul>
        </div>

        <div class="follows">
          <div class="title">追蹤先知命局</div>
          <ul class="follow-list">
            <li
              v-for="(item, index) in contactList"
              :key="index"
              @click="toMedia(item)"
            >
              <img
                :src="getContactIcon(item.icon)"
                alt=""
              />
            </li>
          </ul>
        </div>
      </div>

      <div class="bottom-wrap">
        <p class="copyright">Copyright © 2026先知命局 版權所有</p>
        <ul class="xieyi-list">
          <li
            v-for="(item, index) in xieyiList"
            :key="index"
            @click="goLink(item.url)"
          >
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { logEvent } from '@/utils/analytics';
import { KEFU_LINK } from '@/utils/footer-const';
import logoFooter from '@/assets/images/footer/logo.png';
import visaIcon from '@/assets/images/footer/pay-icon-list/visa.png';
import paypalIcon from '@/assets/images/footer/pay-icon-list/paypal.png';
import octopusIcon from '@/assets/images/footer/pay-icon-list/octopus.png';
import paymeIcon from '@/assets/images/footer/pay-icon-list/payme.png';
import alipayIcon from '@/assets/images/footer/pay-icon-list/alipay.png';
import wechatpayIcon from '@/assets/images/footer/pay-icon-list/WeChatpay.png';
import linepayIcon from '@/assets/images/footer/pay-icon-list/linepay.png';
import pxpayplusIcon from '@/assets/images/footer/pay-icon-list/pxpayplus.png';
import icashIcon from '@/assets/images/footer/pay-icon-list/icash.png';
import myacrdIcon from '@/assets/images/footer/pay-icon-list/myacrd.png';
import touchIcon from '@/assets/images/footer/pay-icon-list/touch.png';
import fpxIcon from '@/assets/images/footer/pay-icon-list/FPX.png';
import shopeeIcon from '@/assets/images/footer/pay-icon-list/shopee.png';
import grabIcon from '@/assets/images/footer/pay-icon-list/grab.png';
import danaIcon from '@/assets/images/footer/pay-icon-list/dana.png';
import facebookIcon from '@/assets/images/footer/facebook@2x (1).png';
import insIcon from '@/assets/images/footer/ins@2x.png';
import lineIcon from '@/assets/images/footer/Line@2x (1).png';
import whatsappIcon from '@/assets/images/footer/WhatsApp@2x.png';
import youtubeIcon from '@/assets/images/footer/YouTube@2x.png';
import tiktokIcon from '@/assets/images/footer/tiktok@2x.png';
import xIcon from '@/assets/images/footer/x@2x.png';

function goLink(url) {
  if (!url) return;
  const isFull = /^https?:\/\//.test(url);
  const full = isFull ? url : `${window.location.origin}${url}`;
  window.open(full, '_blank');
}

function toPage(url) {
  goLink(url);
}

const contactList = [
  {
    icon: 'YouTube.png',
    url: 'https://www.youtube.com/@seer002',
    firebaseEvent: 'site_youtude_click',
  },
  {
    icon: 'WhatsApp.png',
    url: 'https://api.whatsapp.com/send?phone=886978572929',
    firebaseEvent: 'site_whatsapp_click',
  },
  {
    icon: 'x.png',
    url: 'https://twitter.com/Seer144859',
    firebaseEvent: 'site_x_click',
  },
  {
    icon: 'facebook.png',
    url: 'https://www.facebook.com/profile.php?id=100063781927649',
    firebaseEvent: 'site_fb_click',
  },
  {
    icon: 'Line.png',
    url: 'https://lin.ee/P06Koie',
    firebaseEvent: 'site_line_click',
  },
  {
    icon: 'ins.png',
    url: 'https://www.instagram.com/official.seeronnet/',
    firebaseEvent: 'site_ins_click',
  },
  {
    icon: 'tiktok.png',
    url: 'https://www.tiktok.com/@official.seer',
    firebaseEvent: 'site_tiktok_click',
  },
];

function toMedia(item) {
  logEvent(item.firebaseEvent);
  goLink(item.url);
}

const xieyiList = [
  {
    url: '/dist/protocol/website/privacy-policy-statement?lang=zh_tw',
    name: '私隱政策聲明',
  },
  {
    url: '/dist/protocol/website/personal-info-collection-statement?lang=zh_tw',
    name: '個人資料收集聲明',
  },
  {
    url: '/dist/protocol/website/platform-terms-of-use?lang=zh_tw',
    name: '平台使用條款',
  },
  {
    url: '/dist/protocol/website/service-agreement?lang=zh_tw',
    name: '服務協議',
  },
  {
    url: '/dist/protocol/website/refund-policy?lang=zh_tw',
    name: '退款政策',
  },
];

const companyInformation = [
  {
    text: '關於先知命局',
    url: 'https://seerq.io/seer/aboutus',
  },
  {
    text: '新聞室',
    url: 'https://seerq.io/seer/aboutus?to=newsroom',
  },
];

const helps = [
  {
    text: '幫助中心',
    url: KEFU_LINK,
  },
  {
    text: '與先知命局合作',
    url: 'https://seerq.io/seer/aboutus?to=cooperate',
  },
];

const payIconMap = {
  visa: visaIcon,
  paypal: paypalIcon,
  octopus: octopusIcon,
  payme: paymeIcon,
  alipay: alipayIcon,
  WeChatpay: wechatpayIcon,
  linepay: linepayIcon,
  pxpayplus: pxpayplusIcon,
  icash: icashIcon,
  myacrd: myacrdIcon,
  touch: touchIcon,
  FPX: fpxIcon,
  shopee: shopeeIcon,
  grab: grabIcon,
  dana: danaIcon,
};

const contactIconMap = {
  'YouTube.png': youtubeIcon,
  'WhatsApp.png': whatsappIcon,
  'x.png': xIcon,
  'facebook.png': facebookIcon,
  'Line.png': lineIcon,
  'ins.png': insIcon,
  'tiktok.png': tiktokIcon,
};

function getContactIcon(iconName) {
  return contactIconMap[iconName] || '';
}

const payIconList = [
  'visa',
  'paypal',
  'octopus',
  'payme',
  'alipay',
  'WeChatpay',
  'linepay',
  'pxpayplus',
  'icash',
  'myacrd',
  'touch',
  'FPX',
  'shopee',
  'grab',
  'dana',
].map((v) => payIconMap[v]);
</script>

<style lang="scss" scoped>
@use 'sass:math';
@import '@/assets/scss/common.scss';

@function pcrem($px) {
  @return math.div($px, 80) * 1rem;
}

.pc-footer {
  min-width: pcrem(1168);
  background: #fff;
  border-top: 1px solid #efefef;

  .pc-footer-content {
    padding-top: pcrem(36);
    margin: 0 auto;
    width: pcrem(1168);
    max-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    box-sizing: border-box;

    .top-wrap {
      display: flex;

      .company-information,
      .helps {
        .title {
          margin-top: pcrem(22);
          margin-bottom: pcrem(25);
          font-weight: bold;
          font-size: pcrem(18);
          color: #333;
        }

        ul {
          list-style: none;
          margin: 0;
          padding: 0;

          li {
            white-space: nowrap;
            font-size: pcrem(15);
            color: #a0a0a0;
            line-height: pcrem(32);
            cursor: pointer;
          }
        }
      }

      .company-information {
        li:nth-child(2) {
          font-size: pcrem(13);
        }
      }

      .helps {
        margin: 0 auto 0 pcrem(117);
      }

      .info {
        width: pcrem(420);
        font-size: pcrem(15);
        color: #a0a0a0;
        line-height: pcrem(24);

        .logo {
          margin-bottom: pcrem(25);
          display: block;
          width: pcrem(200);
          height: auto;
        }

        .info-item {
          display: flex;

          .label {
            white-space: nowrap;
            color: #333;
          }

          .value {
            color: #a0a0a0;
          }
        }
      }
    }

    .center-wrap {
      margin: pcrem(35) 0 pcrem(20);
      display: flex;

      .we-accept,
      .follows {
        .title {
          margin-bottom: pcrem(24);
          font-family: 'Source Han Sans CN', 'PingFang SC', sans-serif;
          font-weight: bold;
          font-size: pcrem(18);
          color: #333;
        }

        .pay-list {
          display: grid;
          grid-template-columns: repeat(7, pcrem(72));
          gap: pcrem(12) pcrem(8);
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .pay-icon {
          margin: 0;
          width: pcrem(72);
          height: auto;
          display: block;
        }

        .follow-list {
          display: flex;
          list-style: none;
          margin: 0;
          padding: 0;
          gap: 0;

          img {
            margin-right: pcrem(16);
            width: pcrem(32);
            height: pcrem(32);
            cursor: pointer;
            object-fit: contain;
          }
        }
      }

      .we-accept {
        flex: 1;
      }

      .follows {
        width: pcrem(417);
      }
    }

    .bottom-wrap {
      padding: pcrem(37) 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: pcrem(12);
      border-top: 1px solid #efefef;

      .xieyi-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        list-style: none;
        margin: 0;
        padding: 0;
        font-family: 'Source Han Sans CN', 'PingFang SC', sans-serif;
        font-size: pcrem(13);
        color: #a0a0a0;

        li {
          margin-left: pcrem(40);
          position: relative;

          &:first-child {
            margin-left: 0;
          }

          span {
            cursor: pointer;
          }

          &:not(:first-child)::after {
            content: '';
            width: 0;
            height: pcrem(12);
            border-left: 1px solid #efefef;
            position: absolute;
            top: 50%;
            left: pcrem(-21);
            transform: translateY(-50%);
          }
        }
      }

      .copyright {
        margin: 0;
        font-family: 'Source Han Sans CN', 'PingFang SC', sans-serif;
        font-size: pcrem(13);
        color: #a0a0a0;
      }
    }
  }
}

@media (max-width: 768px) {
  .pc-footer {
    display: none;
  }
}
</style>
